/**
 * GPerformance - Delivery ETA widget
 * Trigger link -> modal (krajina + PSC) -> fetch na Cloudflare Worker
 * -> zobrazenie terminov DHL Express / UPS. PSC sa uklada do localStorage,
 * pri dalsej navsteve sa terminy zobrazia rovno inline.
 */
(function () {
  "use strict";

  var root = document.getElementById("gp-eta");
  if (!root || root.dataset.gpEtaInit) return;
  root.dataset.gpEtaInit = "1";

  var ENDPOINT = (root.dataset.endpoint || "").replace(/\/+$/, "");
  var LOCALE = (root.dataset.locale || "en").toLowerCase();
  var PAGE_COUNTRY = (root.dataset.country || "").toUpperCase();
  var HEAVY = root.dataset.heavy === "1";
  var STORAGE_KEY = "gp_eta_dest";
  var HTML_LANG = document.documentElement.lang || LOCALE;

  var COUNTRIES = [
    "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR",
    "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK",
    "SI", "ES", "SE"
  ];

  var ZIP_PATTERNS = {
    AT: /^\d{4}$/, BE: /^\d{4}$/, BG: /^\d{4}$/, HR: /^\d{5}$/, CY: /^\d{4}$/,
    CZ: /^\d{3} ?\d{2}$/, DK: /^\d{4}$/, EE: /^\d{5}$/, FI: /^\d{5}$/,
    FR: /^\d{5}$/, DE: /^\d{5}$/, GR: /^\d{3} ?\d{2}$/, HU: /^\d{4}$/,
    IE: /^[A-Z]\d{2} ?[A-Z0-9]{4}$/i, IT: /^\d{5}$/, LV: /^(LV-)?\d{4}$/i,
    LT: /^(LT-)?\d{5}$/i, LU: /^\d{4}$/, MT: /^[A-Z]{3} ?\d{4}$/i,
    NL: /^\d{4} ?[A-Z]{2}$/i, PL: /^\d{2}-?\d{3}$/, PT: /^\d{4}-?\d{3}$/,
    RO: /^\d{6}$/, SK: /^\d{3} ?\d{2}$/, SI: /^\d{4}$/, ES: /^\d{5}$/,
    SE: /^\d{3} ?\d{2}$/
  };

  var I18N = {
    en: { trigger: "Check delivery date", change: "Change postal code", title: "Where should we deliver?", subtitle: "Enter your postal code and we'll show the delivery date for each shipping option.", country: "Country", zip: "Postal code", submit: "Check", loading: "Checking delivery times…", invalidZip: "Please enter a valid postal code.", error: "Delivery estimate is currently unavailable. Please try again later.", cutoff: "order by {time}", remaining: "{left} left", close: "Close", fast24: "Fastest shipping, often less than 24 h (on business days)", showMore: "Show more", showLess: "Show less", toYou: "at your address", inStock: "In stock", unit: "pcs" },
    sk: { trigger: "Zisti termín doručenia", change: "Zmeň PSČ", title: "Kam to máme doručiť?", subtitle: "Zadaj PSČ a ukážeme ti termín doručenia pre každý spôsob dopravy.", country: "Krajina", zip: "PSČ", submit: "Zistiť", loading: "Zisťujem termíny doručenia…", invalidZip: "Zadaj platné PSČ.", error: "Termín doručenia sa momentálne nedá zistiť. Skús to neskôr.", cutoff: "objednaj do {time}", remaining: "zostáva {left}", close: "Zavrieť", fast24: "Najrýchlejšia doprava, často menej ako 24 h (cez pracovné dni)", showMore: "Zobraziť viac", showLess: "Zobraziť menej", toYou: "u teba", inStock: "Skladom", unit: "ks" },
    cs: { trigger: "Zjisti termín doručení", change: "Změň PSČ", title: "Kam to máme doručit?", subtitle: "Zadej PSČ a ukážeme ti termín doručení pro každý způsob dopravy.", country: "Země", zip: "PSČ", submit: "Zjistit", loading: "Zjišťuji termíny doručení…", invalidZip: "Zadej platné PSČ.", error: "Termín doručení se momentálně nedaří zjistit. Zkus to později.", cutoff: "objednej do {time}", remaining: "zbývá {left}", close: "Zavřít", fast24: "Nejrychlejší doprava, často méně než 24 h (v pracovní dny)", showMore: "Zobrazit více", showLess: "Zobrazit méně", toYou: "u tebe", inStock: "Skladem", unit: "ks" },
    de: { trigger: "Liefertermin prüfen", change: "PLZ ändern", title: "Wohin sollen wir liefern?", subtitle: "Gib deine PLZ ein und wir zeigen dir den Liefertermin für jede Versandart.", country: "Land", zip: "PLZ", submit: "Prüfen", loading: "Liefertermine werden ermittelt…", invalidZip: "Bitte gib eine gültige PLZ ein.", error: "Der Liefertermin kann derzeit nicht ermittelt werden. Bitte versuche es später erneut.", cutoff: "bestelle bis {time}", remaining: "noch {left}", close: "Schließen", fast24: "Schnellster Versand, oft weniger als 24 h (an Werktagen)", showMore: "Mehr anzeigen", showLess: "Weniger anzeigen", toYou: "bei dir", inStock: "Auf Lager", unit: "Stk." },
    fr: { trigger: "Voir la date de livraison", change: "Modifier le code postal", title: "Où devons-nous livrer ?", subtitle: "Saisis ton code postal et nous te montrerons la date de livraison pour chaque mode d'expédition.", country: "Pays", zip: "Code postal", submit: "Vérifier", loading: "Recherche des délais de livraison…", invalidZip: "Saisis un code postal valide.", error: "La date de livraison est momentanément indisponible. Réessaie plus tard.", cutoff: "commande avant {time}", remaining: "il reste {left}", close: "Fermer", fast24: "Livraison la plus rapide, souvent moins de 24 h (jours ouvrés)", showMore: "Afficher plus", showLess: "Afficher moins", toYou: "chez toi", inStock: "En stock", unit: "pcs" },
    es: { trigger: "Ver la fecha de entrega", change: "Cambiar código postal", title: "¿Dónde entregamos?", subtitle: "Introduce tu código postal y te mostraremos la fecha de entrega para cada método de envío.", country: "País", zip: "Código postal", submit: "Consultar", loading: "Consultando plazos de entrega…", invalidZip: "Introduce un código postal válido.", error: "La fecha de entrega no está disponible en este momento. Inténtalo de nuevo más tarde.", cutoff: "pide antes de las {time}", remaining: "quedan {left}", close: "Cerrar", fast24: "Envío más rápido, a menudo menos de 24 h (días laborables)", showMore: "Mostrar más", showLess: "Mostrar menos", toYou: "en tu casa", inStock: "En stock", unit: "uds." },
    it: { trigger: "Scopri la data di consegna", change: "Cambia CAP", title: "Dove consegniamo?", subtitle: "Inserisci il CAP e ti mostreremo la data di consegna per ogni metodo di spedizione.", country: "Paese", zip: "CAP", submit: "Verifica", loading: "Verifica dei tempi di consegna…", invalidZip: "Inserisci un CAP valido.", error: "La data di consegna non è al momento disponibile. Riprova più tardi.", cutoff: "ordina entro le {time}", remaining: "mancano {left}", close: "Chiudi", fast24: "Spedizione più veloce, spesso meno di 24 h (giorni lavorativi)", showMore: "Mostra di più", showLess: "Mostra meno", toYou: "a casa tua", inStock: "Disponibile", unit: "pz" },
    nl: { trigger: "Bezorgdatum bekijken", change: "Postcode wijzigen", title: "Waar moeten we bezorgen?", subtitle: "Voer je postcode in en we tonen je de bezorgdatum voor elke verzendmethode.", country: "Land", zip: "Postcode", submit: "Controleren", loading: "Levertijden worden opgehaald…", invalidZip: "Voer een geldige postcode in.", error: "De bezorgdatum is momenteel niet beschikbaar. Probeer het later opnieuw.", cutoff: "bestel vóór {time}", remaining: "nog {left}", close: "Sluiten", fast24: "Snelste verzending, vaak minder dan 24 u (op werkdagen)", showMore: "Meer weergeven", showLess: "Minder weergeven", toYou: "bij jou", inStock: "Op voorraad", unit: "st." },
    pl: { trigger: "Sprawdź termin dostawy", change: "Zmień kod pocztowy", title: "Gdzie mamy dostarczyć?", subtitle: "Podaj kod pocztowy, a pokażemy termin dostawy dla każdej metody wysyłki.", country: "Kraj", zip: "Kod pocztowy", submit: "Sprawdź", loading: "Sprawdzam terminy dostawy…", invalidZip: "Podaj prawidłowy kod pocztowy.", error: "Termin dostawy jest chwilowo niedostępny. Spróbuj ponownie później.", cutoff: "zamów do {time}", remaining: "pozostało {left}", close: "Zamknij", fast24: "Najszybsza dostawa, często mniej niż 24 h (w dni robocze)", showMore: "Pokaż więcej", showLess: "Pokaż mniej", toYou: "u Ciebie", inStock: "W magazynie", unit: "szt." },
    hu: { trigger: "Szállítási idő megtekintése", change: "Irányítószám módosítása", title: "Hová szállítsunk?", subtitle: "Add meg az irányítószámod, és megmutatjuk a kézbesítési dátumot minden szállítási módhoz.", country: "Ország", zip: "Irányítószám", submit: "Ellenőrzés", loading: "Szállítási idők lekérdezése…", invalidZip: "Adj meg érvényes irányítószámot.", error: "A szállítási idő jelenleg nem érhető el. Próbáld újra később.", cutoff: "rendelj {time}-ig", remaining: "még {left}", close: "Bezárás", fast24: "Leggyorsabb szállítás, gyakran kevesebb mint 24 óra (munkanapokon)", showMore: "Több megjelenítése", showLess: "Kevesebb megjelenítése", toYou: "nálad", inStock: "Raktáron", unit: "db" },
    ro: { trigger: "Vezi data livrării", change: "Schimbă codul poștal", title: "Unde livrăm?", subtitle: "Introdu codul poștal și îți arătăm data de livrare pentru fiecare metodă de expediere.", country: "Țara", zip: "Cod poștal", submit: "Verifică", loading: "Se verifică termenele de livrare…", invalidZip: "Introdu un cod poștal valid.", error: "Data livrării nu este disponibilă momentan. Încearcă din nou mai târziu.", cutoff: "comandă până la {time}", remaining: "mai sunt {left}", close: "Închide", fast24: "Cea mai rapidă livrare, adesea sub 24 h (în zilele lucrătoare)", showMore: "Afișează mai mult", showLess: "Afișează mai puțin", toYou: "la tine", inStock: "În stoc", unit: "buc." },
    da: { trigger: "Se leveringsdato", change: "Skift postnummer", title: "Hvor skal vi levere?", subtitle: "Indtast dit postnummer, og vi viser leveringsdatoen for hver leveringsmetode.", country: "Land", zip: "Postnummer", submit: "Tjek", loading: "Henter leveringstider…", invalidZip: "Indtast et gyldigt postnummer.", error: "Leveringsdatoen er ikke tilgængelig i øjeblikket. Prøv igen senere.", cutoff: "bestil inden kl. {time}", remaining: "{left} tilbage", close: "Luk", fast24: "Hurtigste levering, ofte under 24 timer (på hverdage)", showMore: "Vis mere", showLess: "Vis mindre", toYou: "hos dig", inStock: "På lager", unit: "stk." }
  };

  var ICONS = {
    plane:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"/></svg>',
    truck:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M1 4h14v12H1z"/><path d="M15 9h4l4 4v3h-8V9z"/>' +
      '<circle cx="6" cy="19" r="2"/><circle cx="18" cy="19" r="2"/></svg>',
    h24:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
      '<circle cx="12" cy="12" r="10"/>' +
      '<text x="12" y="15.5" text-anchor="middle" font-size="8.5" font-weight="700" fill="currentColor" stroke="none">24h</text></svg>'
  };

  function t(key) {
    var dict = I18N[LOCALE] || I18N.en;
    return dict[key] || I18N.en[key] || key;
  }

  /* ---------- helpers ---------- */

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function countryName(code) {
    try {
      return new Intl.DisplayNames([HTML_LANG], { type: "region" }).of(code) || code;
    } catch (e) {
      return code;
    }
  }

  function formatDateLong(iso) {
    try {
      var s = new Intl.DateTimeFormat(HTML_LANG, {
        weekday: "long",
        day: "numeric",
        month: "numeric"
      }).format(new Date(iso + "T12:00:00"));
      return s.charAt(0).toUpperCase() + s.slice(1);
    } catch (e) {
      return iso;
    }
  }

  function getSaved() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (d && d.c && d.z && COUNTRIES.indexOf(d.c) !== -1) return d;
    } catch (e) {}
    return null;
  }

  function save(country, zip) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ c: country, z: zip }));
    } catch (e) {}
  }

  function validZip(country, zip) {
    var p = ZIP_PATTERNS[country];
    return p ? p.test(zip) : /^[A-Z0-9 -]{3,10}$/i.test(zip);
  }

  function fetchEta(country, zip) {
    var url = ENDPOINT + "/?country=" + encodeURIComponent(country) + "&zip=" + encodeURIComponent(zip);
    return fetch(url).then(function (res) {
      if (!res.ok) throw new Error("HTTP " + res.status);
      return res.json();
    });
  }

  /* ---------- inline blok ---------- */

  var inline = el("div", "gp-eta__inline");

  if (root.dataset.showStock === "1") {
    var stockLine = el("div", "gp-eta__stock");
    var stockQty = parseInt(root.dataset.stockQty, 10);
    var stockLabel = t("inStock");
    if (root.dataset.stockTracked === "1" && !isNaN(stockQty) && stockQty > 0) {
      stockLabel += " " + (stockQty > 5 ? "> 5" : stockQty) + " " + t("unit");
    }
    stockLine.textContent = stockLabel;
    inline.appendChild(stockLine);
  }

  var results = el("div", "gp-eta__results");
  var trigger = el("button", "gp-eta__trigger");
  trigger.type = "button";
  var triggerIcon = el("span", "gp-eta__trigger-icon");
  triggerIcon.setAttribute("aria-hidden", "true");
  triggerIcon.innerHTML = ICONS.truck;
  var triggerLabel = el("span", null, t("trigger"));
  trigger.appendChild(triggerIcon);
  trigger.appendChild(triggerLabel);
  inline.appendChild(results);
  inline.appendChild(trigger);
  root.appendChild(inline);

  // Zarovnaj cenu s obsahom karty (18px padding) - len ked widget existuje
  var sectionEl = root.closest(".shopify-section") || document;
  var priceEl = sectionEl.querySelector(".product__price");
  if (priceEl) priceEl.classList.add("gp-eta-aligned");

  function buildRow(c) {
    var row = el("div", "gp-eta__row");
    var icon = el("span", "gp-eta__icon");
    icon.setAttribute("aria-hidden", "true");
    icon.innerHTML = c.service === "express" ? ICONS.plane : ICONS.truck;
    row.appendChild(icon);

    var text = el("span", "gp-eta__text");
    text.appendChild(el("strong", null, formatDateLong(c.deliveryDate)));
    text.appendChild(document.createTextNode(" " + t("toYou")));
    text.appendChild(el("span", "gp-eta__carrier", " \u00b7 " + c.name));
    if (c.cutoffToday && c.cutoffAt) {
      var note = el("span", "gp-eta__cutoff");
      note.setAttribute("data-gp-cutoff-at", c.cutoffAt);
      note.setAttribute("data-gp-cutoff-label", c.cutoff);
      setCutoffText(note);
      ensureTimer();
      text.appendChild(note);
    }
    row.appendChild(text);
    return row;
  }

  function renderResults(container, data, collapsible) {
    container.textContent = "";
    var list = data.carriers;
    if (HEAVY) {
      // Tazke produkty: len road/economy sluzby, expresne sa skryju
      list = list.filter(function (c) { return c.service !== "express"; });
    }

    // Datum -> kurier (DHL sluzby pod sebou) -> cas dorucenia
    var sortRows = function (a, b) {
      return (
        (a.deliveryDate || "9999").localeCompare(b.deliveryDate || "9999") ||
        a.id.localeCompare(b.id) ||
        (a.deliveryTime || "99:99").localeCompare(b.deliveryTime || "99:99")
      );
    };
    var air = list.filter(function (c) { return c.service === "express"; }).sort(sortRows);
    var road = list.filter(function (c) { return c.service !== "express"; }).sort(sortRows);

    // V inline karte su viditelne prve 3 metody (+ motivator),
    // vsetko dalsie ide do zbalenej casti za "Zobrazit viac"
    var target = container;
    var moreWrap = null;
    var rowCount = 0;
    var append = function (node, isRow) {
      if (collapsible && rowCount >= 1 && !moreWrap) {
        moreWrap = el("div", "gp-eta__more");
        container.appendChild(moreWrap);
        target = moreWrap;
      }
      target.appendChild(node);
      if (isRow) rowCount++;
    };

    // Maly motivator len pod DHL Express 12:00 - ak sa tato sluzba
    // nezobrazi (alebo nedoruci hned na dalsi den), motivator nebude
    var bannerDone = false;
    air.forEach(function (c) {
      append(buildRow(c), true);
      if (
        !bannerDone &&
        c.name === "DHL Express 12:00" &&
        c.deliveryDate === nextDayIso(c.shipDate)
      ) {
        var banner = el("div", "gp-eta__banner");
        var bIcon = el("span", "gp-eta__banner-icon");
        bIcon.setAttribute("aria-hidden", "true");
        bIcon.innerHTML = ICONS.h24;
        banner.appendChild(bIcon);
        banner.appendChild(el("span", null, t("fast24")));
        append(banner, false);
        bannerDone = true;
      }
    });

    // Cestne sluzby priamo pod leteckymi, oddelene tenkou ciarou
    if (air.length && road.length) {
      append(el("div", "gp-eta__divider"), false);
    }
    road.forEach(function (c) { append(buildRow(c), true); });

    if (collapsible) {
      root.classList.remove("gp-eta--open");
      root.classList.toggle("gp-eta--has-more", !!moreWrap);
      // Toggle je poslednym prvkom karty - az pod "Zmenit PSC" linkom
      var host = container.parentNode || container;
      var oldToggle = host.querySelector(".gp-eta__toggle");
      if (oldToggle) oldToggle.parentNode.removeChild(oldToggle);
      if (moreWrap) {
        var toggle = el("button", "gp-eta__toggle");
        toggle.type = "button";
        var toggleLabel = el("span", null, "");
        var toggleIcon = el("span", "gp-eta__toggle-icon");
        toggleIcon.setAttribute("aria-hidden", "true");
        toggleIcon.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
        toggle.appendChild(toggleLabel);
        toggle.appendChild(toggleIcon);
        var setToggleLabel = function () {
          var open = root.classList.contains("gp-eta--open");
          toggleLabel.textContent = open ? t("showLess") : t("showMore");
          toggle.classList.toggle("gp-eta__toggle--open", open);
        };
        setToggleLabel();
        toggle.addEventListener("click", function () {
          root.classList.toggle("gp-eta--open");
          setToggleLabel();
        });
        host.appendChild(toggle);
      }
    }

    return list.length;
  }

  function nextDayIso(iso) {
    var d = new Date(new Date(iso + "T12:00:00Z").getTime() + 86400000);
    return d.toISOString().slice(0, 10);
  }

  /* ---------- countdown ---------- */

  var cdTimer = null;
  var lastAutoRefresh = 0;

  function setCutoffText(span) {
    var at = parseInt(span.getAttribute("data-gp-cutoff-at"), 10);
    if (at - Date.now() <= 0) return false;
    var label = span.getAttribute("data-gp-cutoff-label");
    span.textContent = " (" + t("cutoff").replace("{time}", label) + ")";
    return true;
  }

  function updateCountdowns() {
    var spans = document.querySelectorAll("[data-gp-cutoff-at]");
    if (!spans.length) {
      if (cdTimer) { clearInterval(cdTimer); cdTimer = null; }
      return;
    }
    var expired = false;
    for (var i = 0; i < spans.length; i++) {
      if (!setCutoffText(spans[i])) expired = true;
    }
    // Cutoff prave presiel - pretiahni cerstve data (novy ship date,
    // posunuty datum dorucenia). Guard proti opakovanym fetchom.
    if (expired && Date.now() - lastAutoRefresh > 60000) {
      lastAutoRefresh = Date.now();
      refreshEta();
    }
  }

  function ensureTimer() {
    if (!cdTimer) cdTimer = setInterval(updateCountdowns, 30000);
  }

  function refreshEta() {
    var s = getSaved();
    if (s) loadInline(s);
    if (overlay && !overlay.hasAttribute("hidden") && overlay._results.childNodes.length) {
      fetchEta(overlay._select.value, overlay._input.value.trim().toUpperCase())
        .then(function (data) { renderResults(overlay._results, data); })
        .catch(function () {});
    }
  }

  function loadInline(dest) {
    fetchEta(dest.c, dest.z)
      .then(function (data) {
        if (renderResults(results, data, true) > 0) {
          triggerLabel.textContent = t("change") + " (" + dest.c + " " + dest.z + ")";
        } else {
          triggerLabel.textContent = t("trigger");
        }
      })
      .catch(function () {
        // tichy fallback - ziadna chybova hlaska na produktovke
        results.textContent = "";
        root.classList.remove("gp-eta--open", "gp-eta--has-more");
        triggerLabel.textContent = t("trigger");
      });
  }

  /* ---------- modal ---------- */

  var overlay = null;
  var lastFocused = null;

  function buildModal() {
    overlay = el("div", "gp-eta__overlay");
    overlay.setAttribute("hidden", "");

    var dialog = el("div", "gp-eta__dialog");
    dialog.setAttribute("role", "dialog");
    dialog.setAttribute("aria-modal", "true");
    dialog.setAttribute("aria-label", t("title"));

    var head = el("div", "gp-eta__head");
    head.appendChild(el("h3", "gp-eta__title", t("title")));
    var closeBtn = el("button", "gp-eta__close", "\u00d7");
    closeBtn.type = "button";
    closeBtn.setAttribute("aria-label", t("close"));
    head.appendChild(closeBtn);
    dialog.appendChild(head);
    dialog.appendChild(el("p", "gp-eta__subtitle", t("subtitle")));

    var body = el("div", "gp-eta__body");

    // form
    var form = el("div", "gp-eta__form");

    var countryLabel = el("label", "gp-eta__label", t("country"));
    countryLabel.setAttribute("for", "gp-eta-country");
    var select = el("select", "gp-eta__select");
    select.id = "gp-eta-country";
    COUNTRIES
      .map(function (code) { return { code: code, name: countryName(code) }; })
      .sort(function (a, b) { return a.name.localeCompare(b.name, HTML_LANG); })
      .forEach(function (c) {
        var opt = document.createElement("option");
        opt.value = c.code;
        opt.textContent = c.name;
        select.appendChild(opt);
      });

    var zipLabel = el("label", "gp-eta__label", t("zip"));
    zipLabel.setAttribute("for", "gp-eta-zip");
    var input = el("input", "gp-eta__input");
    input.id = "gp-eta-zip";
    input.type = "text";
    input.autocomplete = "postal-code";
    input.inputMode = "text";
    input.maxLength = 10;

    var submit = el("button", "gp-eta__submit", t("submit"));
    submit.type = "button";

    var msg = el("p", "gp-eta__msg");
    msg.setAttribute("role", "status");

    form.appendChild(countryLabel);
    form.appendChild(select);
    form.appendChild(zipLabel);
    form.appendChild(input);
    form.appendChild(submit);
    form.appendChild(msg);

    var modalResults = el("div", "gp-eta__results gp-eta__results--modal");

    body.appendChild(form);
    body.appendChild(modalResults);
    dialog.appendChild(body);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    function doSubmit() {
      var country = select.value;
      var zip = input.value.trim().toUpperCase();
      msg.textContent = "";
      modalResults.textContent = "";
      if (!validZip(country, zip)) {
        msg.textContent = t("invalidZip");
        input.focus();
        return;
      }
      submit.disabled = true;
      msg.textContent = t("loading");
      fetchEta(country, zip)
        .then(function (data) {
          save(country, zip);
          msg.textContent = "";
          if (renderResults(modalResults, data) === 0) {
            msg.textContent = t("error");
          }
          loadInline({ c: country, z: zip });
        })
        .catch(function () {
          msg.textContent = t("error");
        })
        .then(function () {
          submit.disabled = false;
        });
    }

    submit.addEventListener("click", doSubmit);
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        doSubmit();
      }
    });
    closeBtn.addEventListener("click", closeModal);
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !overlay.hasAttribute("hidden")) closeModal();
    });

    overlay._select = select;
    overlay._input = input;
    overlay._msg = msg;
    overlay._results = modalResults;
  }

  function openModal() {
    if (!overlay) buildModal();
    lastFocused = document.activeElement;
    var saved = getSaved();
    overlay._select.value = (saved && saved.c) || (COUNTRIES.indexOf(PAGE_COUNTRY) !== -1 ? PAGE_COUNTRY : "DE");
    overlay._input.value = (saved && saved.z) || "";
    overlay._msg.textContent = "";
    overlay._results.textContent = "";
    overlay.removeAttribute("hidden");
    document.body.classList.add("gp-eta-lock");
    overlay._input.focus();
  }

  function closeModal() {
    overlay.setAttribute("hidden", "");
    document.body.classList.remove("gp-eta-lock");
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  trigger.addEventListener("click", openModal);

  /* ---------- init ---------- */

  var saved = getSaved();
  if (saved && ENDPOINT) loadInline(saved);
})();